export default __webpack_public_path__ + "static/media/arrow_drop_down.717467ee.svg";